import { Button } from "antd";
import classNames from "classnames";
import PropTypes from "prop-types";

import { getButtonText } from "./ListLoadMoreButton.helper";

const ListLoadMoreButton = ({ pagination, itemName, ...buttonProps }) => {
  const className = classNames("list-load-more-button", buttonProps.className);
  const text = getButtonText(pagination, itemName);

  if (!text) return null;

  return (
    <Button {...buttonProps} className={className}>
      {text}
    </Button>
  );
};

ListLoadMoreButton.propTypes = {
  pagination: PropTypes.object.isRequired,
  itemName: PropTypes.string.isRequired,
};

export default ListLoadMoreButton;
